import { useInfiniteQuery } from 'react-query';

import { photoTagsApi } from 'src/Services/API';

const useFetchMemberPhotoAlbum = (memberId?: string, limit: number = 20) => {
  return useInfiniteQuery({
    queryKey: ['fetch-member-photo-album', memberId, limit],
    queryFn: async ({ pageParam = undefined }) => {
      if (!memberId) throw new Error('Member id not provided');

      return (await photoTagsApi.photoTagsControllerGetMemberPhotoAlbum(memberId, limit, pageParam))
        .data;
    },
    getNextPageParam: lastPage => lastPage.nextCursor,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: !!memberId,
  });
};

export default useFetchMemberPhotoAlbum;
